import { ErrorFallback } from '../../../components/error/ErrorFallback';

/**
 * 403 page (HOMCO-640): shown when `ProtectedRoute` blocks a route the connected
 * profile lacks the permission for. Reuses `ErrorFallback` (title + message +
 * back-home button) like `NotFoundPage`; the message comes from
 * `error.types.access_forbidden`.
 */
export function ForbiddenPage() {
  // `ErrorFallback` keys its title/message off the Error message, so the sentinel
  // `access_forbidden` (an `ErrorTypes`) selects the 403 copy.
  return <ErrorFallback error={new Error('access_forbidden')} resetError={() => {}} />;
}
